import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const utilitiesRoute = ({
  Archives,
  // AddArchive,
  // EditArchive
}: {
  Archives: React.ComponentType;
  // AddArchive: React.ComponentType;
  // EditArchive: React.ComponentType;
}) => (
  <Routes>
    <Route path={ROUTES.UTILITIES.ARCHIVES.BASE} element={<Archives />} />
    {/* <Route path={ROUTES.UTILITIES.ARCHIVES.ADD} element={<AddArchive />} />
    <Route path={ROUTES.UTILITIES.ARCHIVES.EDIT} element={<AddArchive />} /> */}
  </Routes>
);
